import React from 'react'
import { useParams } from 'react-router-dom'

//UI
import { Box } from '@chakra-ui/react'
import VendorDetailForm from '../components/VendorDetailForm'

//API
import useVendor from '../useVendor'

const AdminVendorDetailPage = () => {
  const { id } = useParams()
  const { useFetchVendor } = useVendor()

  const { data: vendor } = useFetchVendor(id)

  return (
    <Box shadow="md" borderWidth="1px" bg="white" w="100%" mb="auto" p={5}>
      <VendorDetailForm requestorEmail={''} vendor={vendor} isCreate={false}></VendorDetailForm>
    </Box>
  )
}

export default AdminVendorDetailPage
